<template>
    <a href="javascript:{}" class="events-group-item">
        <div class="events-group-item--left" @click="go_to_event(person_event.id)">
            <div class="events-group-item-header">
                {{ person_event.name }}
                <!---->
            </div>
            <div class="events-group-item-content">
                <div class="events-group-item-content--date">
                    {{ moment(person_event.event_time).format("dd")[0] }}
                    {{ moment(person_event.event_time).format("DD.MM, HH:mm") }}
                </div>
                <div class="events-group-item-content--attending" v-if="person_event.attendees">
                    <span>Attending {{ person_event.attending_attendees }}/{{ person_event.attendees }}</span>
                </div>
            </div>
        </div>

        <div class="events-group-item--right">
            <div :class="{ 'drop menu-more': true, show: false }">
                <a href="javascript:{}"><span class="icon icon-dots"></span></a>
                <div class="drop-content">
                    <ul>
                        <li>
                            <a class="red" href="javascript:{}">Remove</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import moment from "moment";
import router from "@/router";

export default {
    name: "participating-row",
    props: ["person_event"],
    methods: {
        go_to_event(event_id) {
            router.push({ path: "/events/" + event_id });
        }
    }
};
</script>

<style scoped>
.events-group-item--left {
    flex: 1;
}
</style>
